










































import {Component, Vue} from 'vue-property-decorator'
import CategoryNavi from '@/pages/ItemManagementPage/CategoryNavi.vue'
import CategoryItemList from '@/pages/ItemManagementPage/CategoryItemList.vue'
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import MenusStore from "@/store/modules/MenusStore";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import ThemeVariableStore from "@/store/modules/ThemeVariableStore";
import ThemeCategoryVariablesStore from "@/store/modules/ThemeCategoryVariablesStore";
import ThemeItemVariablesStore from "@/store/modules/ThemeItemVariablesStore";
import ItemDetail from "@/pages/ItemManagementPage/ItemDetail.vue";
import ThemesStore from "@/store/modules/ThemesStore";
import HeaderBar from '@/components/HeaderBar.vue';
import Navigator from '@/components/Navigator.vue';
import StoresStore from '@/store/modules/StoresStore';
import DeliousItemsStore from '@/_common/api/store/modules/DeliousItemsStore';
import GenerationsStore from '@/store/modules/GenerationsStore';
import PluClassesStore from '@/store/modules/PluClassesStore';

@Component({
    components: {
        HeaderBar,
        Navigator,
        CategoryItemList,
        CategoryNavi,
        ItemDetail
    },
})
export default class ItemManagementPage extends Vue {
    private menuType = 1;
    private menuTypeName = 'セットメニュー';
    private dialogVisible = false;

    async created() {
        const menuId: number = Number(this.$route.params.menuId);

        await MenusStore.init();

        const storeId: number = MenusStore.menuById[menuId].store_ids ? Number(MenusStore.menuById[menuId].store_ids[0]) : Number(StoresStore.all[0].code);
        await DeliousItemsStore.init({storeId: storeId, periodId: GenerationsStore.selected.period_no});

        await CategoriesStore.init(menuId);
        await CategoryItemsStore.init(menuId);

        const themeId: number = MenusStore.menuById[menuId].theme_id;
        ThemesStore.selectTheme(themeId)
        ThemeVariableStore.init({themeId: themeId, menuId: menuId});
        ThemeCategoryVariablesStore.init({themeId: themeId, menuId: menuId});
        ThemeItemVariablesStore.init(themeId);
        await PluClassesStore.init({storeId: storeId});

    }

    get categoryId(): number {
        return Number(this.$route.params['categoryId']);
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[Number(this.$route.params.menuId)] || {};
    }

    get isDialogVisible(): boolean {
        return this.dialogVisible
    }

    private handleChangeMenu(type: number, name: string) {
        this.menuType = type
        this.menuTypeName = name
    }

    private handleOpenDialog(): void {
        this.dialogVisible = true
    }

    private handleCloseDialog(): void {
        this.dialogVisible = false
    }

    private handleSelectItem(itemId: number) {
        this.$router.push({name: 'menu_item_detail', params: {itemId: itemId.toString()}});
    }

    private onEndItemEdit() {
        this.$router.push({name: 'menu_item'});
    }

    private onClickCancel() {
        this.$router.push({name: 'menu_top'});
    }

}
